import { render, staticRenderFns } from "./view-caselabel-serials.vue?vue&type=template&id=abbdd520&"
import script from "./view-caselabel-serials.vue?vue&type=script&lang=ts&"
export * from "./view-caselabel-serials.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports